module.exports = __webpack_public_path__ + "static/media/template3.892cd17c.svg";